import { Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { LayerService } from '../../../../services/layer.service';
import { BaseComponent } from '../../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-layer-opacity-editor-ng',
    templateUrl: './layer-opacity-editor.component.html',
    styleUrls: ['../../../sharedStyles/base.scss', '../../../sharedStyles/telerik.scss', './layer-opacity-editor.component.scss']
})

export class LayerOpacityEditorComponent extends BaseComponent {

    private _uniqueLayerId;
    @Input() set uniqueLayerId(value) {
        this._uniqueLayerId = value;
        if (value) {
            this.getLayer();
        }
    }
    get uniqueLayerId() {
        return this._uniqueLayerId;
    }

    @Input() opacity = 1;

    layer;
    showBrightnessText: boolean;
    defaultLayerOpacity = 1;
    opacityMultiplier = 100;

    constructor(_vcr: ViewContainerRef, private readonly layerService: LayerService) { super(_vcr); }

    async getLayer() {
        this.layer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
        this.layer.opacity = this.layer.opacity ? this.layer.opacity : this.defaultLayerOpacity;
        this.opacity = this.layer.opacity * this.opacityMultiplier;
    }

    @Input()
    public applyChange = () => {
        const newOpacity = this.opacity / this.opacityMultiplier;
        if (this.layer && newOpacity !== this.layer.opacity) {
            this.layer.opacity = newOpacity;
            window.dispatchEvent(new CustomEvent<string>('symbolChange', { detail: this.uniqueLayerId }));
        }
    }

    @Input()
    public cancel = () => {
        this.uniqueLayerId = null;
        this.layer = null;
    }
}
